import {
    COLLABORATOR_SENTINEL,
    EVERYONE_SENTINEL,
    referenceSearchQueryTerm,
    UserId,
} from "@sp-crm/core";
import { SelectableUser } from "components/shared/user-select";
import { ReferenceContactSearchRequest } from "generated/graphql";
import { ReferenceFilter } from "store/slices/reference-dashboard";

export interface ReferenceSearchSortValue {
    sort: string;
    sortDirection: "ASC" | "DESC";
}

export interface ReferenceSearchPaging {
    page: number;
    perPage: number;
}

export const actualAssignedUserId = (assignedUserId: SelectableUser): UserId | null =>
    assignedUserId &&
    assignedUserId !== EVERYONE_SENTINEL &&
    assignedUserId !== COLLABORATOR_SENTINEL
        ? (assignedUserId as UserId)
        : null;

export const buildReferenceContactSearchRequest = (
    filter: ReferenceFilter,
    sort: ReferenceSearchSortValue,
    paging: ReferenceSearchPaging,
): Omit<ReferenceContactSearchRequest, "regionId"> => ({
    page: paging.page,
    perPage: paging.perPage,
    search: referenceSearchQueryTerm(filter.search ?? ""),
    sort: sort.sort,
    sortDirection: sort.sortDirection,
    assignedUserId: actualAssignedUserId(filter.assignedUserId),
    organizationTypes: filter.orgTypes,
    communityTypes: filter.communityTypes,
    referralTierIds: filter.referralTierIds,
    bestDaysToVisit: filter.bestDaysToVisit,
    contactCondition: filter.contactCondition,
    businessCondition: filter.businessCondition,
    communityCondition: filter.communityCondition,
    geoParams: filter.geoParams,
});
